<template>
    <div class="section section--detail-list section--detail-list-shifts">
        <div class="pagination" v-if="pages > 1">
            <div class="prev" @click="prev()">
                <svg class="icon icon-chevron-left">
                    <use xlink:href="#chevron-left"></use>
                </svg>
            </div>
            <div v-for="(page, j) in pages" :key="j" class="page" :class="(pageNr == j) ? ' active' : ''" @click="pageNr = j">{{ j + 1 }}</div>
            <div class="next" @click="next()">
                <svg class="icon icon-chevron-left">
                    <use xlink:href="#chevron-left"></use>
                </svg>
            </div>
        </div>
        <div class="detail-list-container">
            <div class="header-list">
                <div class="heading">Settimana</div>
                <div class="heading">Gruppo</div>
                <div class="heading">Dal</div>
                <div class="heading">Al</div>
                <div class="heading">Stato</div>
                <div class="heading">Azioni</div>
            </div>
            <div v-for="(page, x) in pages" :key="x">
                <div v-if="x == pageNr" class="main-list">
                <div class="worker" v-for="(item, index) in itemList.filter((item, index) => index >= (x * 20) && index < (x * 20) + 20)" :key="index">
                    <div class="list-item list-item--inspector">{{ item.week_number }}</div>
                    <div class="list-item list-item--inspector">{{ groupName(item.group_id) }}</div>
                    <div class="list-item list-item--group">{{ dayjs(item.date_start).format('DD-MM-YYYY') }}</div>
                    <div class="list-item list-item--address">{{ dayjs(item.date_end).format('DD-MM-YYYY') }}</div>
                    <div class="list-item list-item--inspector">{{ item.week_status }}</div>
                    <div class="list-item list-item--actions">
                        <div class="icon-container" @click="$emit('visible', true, item)">
                            <svg class="icon icon-visibility">
                                <use xlink:href="#visibility"></use>
                            </svg>
                        </div>
                        <div class="icon-container" @click="$emit('edit', true, item)">
                            <svg class="icon icon-edit_square">
                                <use xlink:href="#edit-square"></use>
                            </svg>
                        </div>
                        <div v-if="item.week_status == 'archiviato'" class="icon-container" @click="$emit('active', true, item)">
                            <svg class="icon icon-folder">
                                <use xlink:href="#reset"></use>
                            </svg>
                        </div>
                        <div v-if="item.week_status !== 'in-corso' && item.week_status !== 'passato' && item.week_status !== 'archiviato'" class="icon-container" @click="$emit('archive', true, item)">
                            <svg class="icon icon-folder">
                                <use xlink:href="#folder"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="pagination" v-if="pages > 1">
                <div class="prev" @click="prev()">
                    <svg class="icon icon-chevron-left">
                        <use xlink:href="#chevron-left"></use>
                    </svg>
                </div>
                <div v-for="(page, j) in pages" :key="j" class="page" :class="(pageNr == j) ? ' active' : ''" @click="pageNr = j">{{ j + 1 }}</div>
                <div class="next" @click="next()">
                    <svg class="icon icon-chevron-left">
                        <use xlink:href="#chevron-left"></use>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

// import workersList from '../models/workers.json'
import dayjs from 'dayjs';

</script>

<script>

export default {
    name : 'detail-list',
    components : {},
    props : {
        itemList : {
            default : null,
            type : Object
        }
    },
    data(){
        return{
            pageNr : 0,
        }
    },
    computed : {
        pages(){
            if(this.itemList.length < 20){
                return 1
            }else{
                if(this.itemList.length % 20 == 0 ){
                    return Math.floor(this.itemList.length / 20)
                }else{
                    return Math.floor(this.itemList.length / 20) + 1
                }
            }
        },
    },
    emits : ['visible', 'edit', 'delete', 'archive'],
    methods : {
        next(){
            if(this.pageNr < this.pages - 1){
                this.pageNr++
            }
        },

        prev(){
            if(this.pageNr > 0){
                this.pageNr--
            }
        },
        groupName(id){
            var groups = JSON.parse(localStorage.getItem('groupsList'))
            var group
            groups.map((item) => {
                if(item.id == id){
                    group = item.group_name
                }
            })

            return group
        },
    },
}

</script>